import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformTaskInterfaceComponent } from './platform-task-interface.component';
import {
  TaskCreationSidebarComponent,
  TaskInterfaceComponent,
  TaskInterfacePanelComponent,
} from '@mtm/task-ui-angular';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { MtmToggleRailComponent } from '@mtm/media-studio';

@NgModule({
  declarations: [PlatformTaskInterfaceComponent],
  imports: [CommonModule, TaskInterfaceComponent, TaskCreationSidebarComponent, TaskInterfacePanelComponent, LoadingSpinnerComponent, MtmToggleRailComponent],
  exports: [PlatformTaskInterfaceComponent],
})
export class PlatformTaskInterfaceModule {}
